export default "/assets/images/tech_page_01.d1626c7575fb1acc.mp4";